import type { SearchModalSection } from '../search-modal.interface'

export const getSearchSectionStartIndexes = (sections: readonly SearchModalSection[]): number[] => {
  const startIndexes: number[] = []
  let runningTotal = 0

  for (const section of sections) {
    startIndexes.push(runningTotal)
    runningTotal += section.items.length
  }

  return startIndexes
}
